var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "purchase_part-header", class: _vm.statusColor },
    [
      _c(
        "p",
        {
          staticClass: "purchase_part-header_number",
          staticStyle: {
            "white-space": "nowrap",
            overflow: "hidden",
            "text-overflow": "ellipsis",
          },
        },
        [
          _vm.purchase.auth_is_supplier
            ? _c(
                "b-badge",
                {
                  staticClass: "my-auto fs-14 mr-2",
                  attrs: { variant: "danger" },
                },
                [_vm._v("Поставщик")]
              )
            : _vm._e(),
          _c(
            "b-badge",
            {
              staticClass: "my-auto fs-14 mr-2",
              attrs: { variant: "primary" },
            },
            [_vm._v(_vm._s(_vm.purchase.product.short_title))]
          ),
          _vm.purchase.product.is_external
            ? _c("b-badge", { staticClass: "my-auto fs-14 mr-2" }, [
                _vm._v("Вне ИС"),
              ])
            : _vm._e(),
          _vm.isPurchasePubliclyAvailable
            ? [
                _vm.purchase.type === "fl44_external"
                  ? _c(
                      "router-link",
                      {
                        staticClass: "white-system_link-style",
                        attrs: {
                          to: {
                            name: "ExternalPurchaseShow",
                            params: { id: _vm.purchase.id },
                          },
                          exact: "",
                          target: "_blank",
                        },
                      },
                      [_vm._v(_vm._s(_vm.purchase.purchase_info.reg_number))]
                    )
                  : _vm.purchase.type === "fl44_unknown_volume"
                  ? _c(
                      "router-link",
                      {
                        staticClass: "white-system_link-style",
                        attrs: {
                          to: {
                            name: "Fl44UnknownVolumePurchaseShow",
                            params: { id: _vm.purchase.id },
                          },
                          exact: "",
                          target: "_blank",
                        },
                      },
                      [_vm._v(_vm._s(_vm.purchase.purchase_info.reg_number))]
                    )
                  : _c(
                      "router-link",
                      {
                        staticClass: "white-system_link-style",
                        attrs: {
                          to: {
                            name: "purchases.grouped.item.view",
                            params: { group: "fl44", id: _vm.purchase.id },
                          },
                          target: "_blank",
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.purchase.purchase_info.reg_number) + " "
                        ),
                      ]
                    ),
              ]
            : [
                _c("span", [
                  _vm._v(_vm._s(_vm.purchase.purchase_info.reg_number)),
                ]),
              ],
          _vm.purchase.purchase_info.purchase_object
            ? _c(
                "span",
                { staticStyle: { "text-overflow": "ellipsis ellipsis" } },
                [
                  _vm._v(
                    ' На закупку "' +
                      _vm._s(_vm.purchase.purchase_info.purchase_object) +
                      '"'
                  ),
                ]
              )
            : _vm._e(),
        ],
        2
      ),
      _c(
        "p",
        {
          staticClass:
            "purchase_part-header_label fw-600 float-right text-right my-auto fs-14 text-nowrap ml-4",
        },
        [
          _vm._v(" " + _vm._s(_vm.purchase.status.title) + " "),
          _c("i", {
            staticClass: "atmo-icon ml-2",
            class: _vm.statusIconClass,
          }),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }